import React, { useState } from 'react';
import Modal from './Modal';
import { Link } from 'react-router-dom';
import { imageUrl } from '../../Constants/contant';

function GalleryOne({ gallery }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState('');

    const openModal = (imageSrc, event) => {
        event.preventDefault();
        setModalImage(imageSrc);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className="gallery-area" id='gallery'>
            <div className="container th-container shape-mockup-wrap">
                <div className="title-area text-center">
                    {/* <span className="sub-title">Make Your Tour More Pleasure</span> */}
                    <h2 className="sec-title">Recent Gallery</h2>
                </div>

                <div className="row gy-10 gx-10 justify-content-center align-items-center">
                    {gallery && gallery.length > 0 ? (
                        gallery?.map((item, index) => (
                            <div className="col-md-6 col-lg-2" key={index}>
                                <div className="gallery-card">
                                    <div className="box-img global-img">
                                        <Link
                                            to="#"
                                            className="popup-image"
                                            onClick={(e) => openModal(item.image, e)}
                                        >
                                            <div className="icon-btn">
                                                <i className="fal fa-magnifying-glass-plus" />
                                            </div>
                                        </Link>
                                        <img
                                            src={imageUrl + item.image}
                                            alt={item.title || `gallery-${index}`}
                                            onClick={(e) => openModal(item.image, e)}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-center">No gallery items found.</p>
                    )}
                </div>

                {/* Decorative shapes */}
                <div className="shape-mockup d-none d-xl-block" style={{ top: "-25%", left: "0%" }}>
                    <img src="/assets/img/shape/line.png" alt="shape" />
                </div>
                <div className="shape-mockup movingX d-none d-xl-block" style={{ top: "30%", left: "-3%" }}>
                    <img className="gmovingX" src="/assets/img/shape/shape_4.png" alt="shape" />
                </div>
            </div>

            <Modal isOpen={isModalOpen} closeModal={closeModal} imageSrc={imageUrl + modalImage} />
        </div>
    );
}

export default GalleryOne;
